export var LICENSE_SCOPES = ['pro', 'premium'];